import { render, staticRenderFns } from "./pad.vue?vue&type=template&id=ed671648&scoped=true"
import script from "./pad.vue?vue&type=script&lang=js"
export * from "./pad.vue?vue&type=script&lang=js"
import style0 from "./pad.vue?vue&type=style&index=0&id=ed671648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed671648",
  null
  
)

export default component.exports